import ChapterAnalytics from 'routes/ChapterAnalytics/ChapterAnalytics';

export default ChapterAnalytics;
